import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";


export interface CreateDispatchPayload {
  dispatch_id: string;
  dispatch_date: string;
  transfer_type: string;
  packing_ids: string[];
  dispatch_status: string;
  remark: string;
  transport_type: string;
  transport_details: {
    vehicle: string;
    driver: string;
    license: string;
  };
  scheduled_date: string;
  expected_delivery_date: string;
  transport_info: {
    transporter_type: string;
    person_name: string;
    person_number: string;
    scheduled_date: string;
    eta_date: string;
    remarks: string;
  }[];
}

// export const fetchWarehouseDispatch = createAsyncThunk(
//   "damage/fetchDispatch",
//   async ({
//     page,
//     pageSize,
//     sort,
//     order,
//     search,
//     filters,
//     type,
//   }: {
//     page: number;
//     pageSize: number;
//     search?: string;
//     sort?: string;
//     order?: "asc" | "desc" | "";
//     filters?: any;
//     type?: string;
//   }) => {
//     const params = new URLSearchParams();
//     params.append("page", page.toString());
//     params.append("page_size", pageSize.toString());
//     if (search) params.append("search", search);
//     if (sort) {
//       const orderingValue = order === "desc" ? `-${sort}` : sort;
//       params.append("ordering", orderingValue);
//     }

//     if (filters && filters.length > 0) {
//       filters.forEach(
//         ({
//           filterField,
//           filterValue,
//         }: {
//           filterField: string;
//           filterValue: any;
//         }) => {
//           if (
//             filterField &&
//             filterValue !== undefined &&
//             filterValue !== null
//           ) {
//             if (typeof filterValue === "object" && filterValue !== null) {
//               // Handle cases like { from_date: ..., to_date: ... }
//               Object.entries(filterValue).forEach(([key, value]) => {
//                 if (value !== undefined && value !== null && value !== "") {
//                   params.append(key, String(value));
//                 }
//                 if (
//                   (filterValue.from_date || filterValue.to_date) &&
//                   (filterField === "created_at" || filterField === "updated_at")
//                 ) {
//                   if (filterField === "created_at") {
//                     filterField = "created";
//                   } else {
//                     filterField = "updated";
//                   }
//                   params.append("filter_by", filterField);
//                 }
//               });
//             } else {
//               // Handle primitive values (string, number)
//               params.append(filterField, filterValue);
//             }
//           }
//         }
//       );
//     }

//     if (type === 'Transfer') {
//       const response: any = await WarehouseAxios.get(
//          `/dispatch/list/?transfer_type=Transfer&${params.toString()}`
//       );
//       console.log("Full API Response:", response);            // logs entire Axios response
//       console.log("Response Data:", response?.data);          // logs response data
//       console.log("Row Count:", response?.data?.count || 0);  // logs count specifically

//       return {
//         data: response?.data?.data || [],
//         rowCount: response?.data?.count || 0,
//       };
//     } else if (type === 'Allocation') {
//       // const response: any = await WarehouseAxios.get(
//       //   `/inventory_item_request/allocations/warehoue-packing-issue-packing-listing/?${params.toString()}`
//       // );
//       const response: any = await WarehouseAxios.get(
//         `/dispatch/list/?transfer_type=Allocation&${params.toString()}`
//       );
//       console.log("response : ", response?.data);
//       return {
//         data: response?.data?.data || [],
//         rowCount: response?.data?.count || 0,
//       };
//       } else if (type === 'Items Request') {
//          const response: any = await WarehouseAxios.get(
//         `/dispatch/list/?transfer_type=Item Request&${params.toString()}`
//       );
//       console.log("response Item Request : ", response);
//       return {
//         data: response?.data?.data || [],
//         rowCount: response?.data?.count || 0,
//       };

//     }else{
//        return {
//         data: [],
//         rowCount: 0,
//       };
//     }
//     // const response: any = await WarehouseAxios.get(
//     //   `/stock/issue-for-packing/list/?${params.toString()}`
//     // );
//   }
// );

export const fetchWarehouseDispatch = createAsyncThunk(
  "damage/fetchDispatch",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    type,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    type?: string;
  }) => {
    const params = new URLSearchParams();

    const hasDispatchDateFilter = filters?.some(
      (f: any) => f.filterField === "dispatch_date"
    );


    if (!hasDispatchDateFilter) {
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
    }

    if (search) params.append("search", search);

    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    // Transfer
    if (type === "Transfer") {
      if (filters?.length > 0) {
        filters.forEach(
          ({ filterField, filterValue }: { filterField: string; filterValue: any }) => {
            if (filterField && filterValue) {
              if (filterField === "dispatch_date") {
                if (filterValue.from_date) {
                  params.append("dispatch_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("dispatch_date_to", filterValue.to_date);
                }
              } else if (filterField === "packing_date") {
                if (filterValue.from_date) {
                  params.append("packing_details.packing_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("packing_details.packing_date_to", filterValue.to_date);
                }
              } else if (filterField === "delivered_date") {
                if (filterValue?.from_date) {
                  params.append("delivered_date_from", filterValue.from_date);
                }
                if (filterValue?.to_date) {
                  params.append("delivered_date_to", filterValue.to_date);
                }
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }
    }

    // Allocation
    if (type === "Allocation") {
      if (filters?.length > 0) {
        filters.forEach(
          ({ filterField, filterValue }: { filterField: string; filterValue: any }) => {
            if (filterField && filterValue) {
              if (filterField === "dispatch_date") {
                if (filterValue.from_date) {
                  params.append("dispatch_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("dispatch_date_to", filterValue.to_date);
                }
              } else if (filterField === "packing_date") {
                if (filterValue.from_date) {
                  params.append("packing_details.packing_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("packing_details.packing_date_to", filterValue.to_date);
                }
              } else if (filterField === "delivered_date") {
                if (filterValue?.from_date) {
                  params.append("delivered_date_from", filterValue.from_date);
                }
                if (filterValue?.to_date) {
                  params.append("delivered_date_to", filterValue.to_date);
                }
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }
    }

      // Items Request
    if (type === "Items Request") {
      if (filters?.length > 0) {
        filters.forEach(
          ({ filterField, filterValue }: { filterField: string; filterValue: any }) => {
            if (filterField && filterValue) {
              if (filterField === "dispatch_date") {
                if (filterValue.from_date) {
                  params.append("dispatch_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("dispatch_date_to", filterValue.to_date);
                }
              } else if (filterField === "packing_date") {
                if (filterValue.from_date) {
                  params.append("packing_details.packing_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("packing_details.packing_date_to", filterValue.to_date);
                }
              } else if (filterField === "delivered_date") {
                if (filterValue?.from_date) {
                  params.append("delivered_date_from", filterValue.from_date);
                }
                if (filterValue?.to_date) {
                  params.append("delivered_date_to", filterValue.to_date);
                }
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }
    }



    let response: any;

    if (type === "Transfer") {
      response = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Transfer&${params.toString()}`
      );
    } else if (type === "Allocation") {
      response = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Allocation&${params.toString()}`
      );
    } else if (type === "Items Request") {
      response = await WarehouseAxios.get(
        `/dispatch/list/?transfer_type=Item Request&${params.toString()}`
      );
    } else {
      return { data: [], rowCount: 0 };
    }

    return {
      data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
    };
  }
);

export const fechCreateDispatch = createAsyncThunk<
  { dispatch_id: string },
  CreateDispatchPayload,
  { rejectValue: any }
>(
  "create-dispatch/fechCreateDispatch",
  async (payload: CreateDispatchPayload, { rejectWithValue }) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";

      console.log("Dispatch Payload:", payload);

      const response = await WarehouseAxios.post(
        "/dispatch/create/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Dispatch Response:", response.data);

      return response.data;
    } catch (error: any) {
      console.error("Dispatch Error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);





// export const exportDraftRFQCSV = async () => {
//   const response = await WarehouseAxios.get("/warehouse/dispatch/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "purchaseRequest.csv",
//   };
// };

export const exportCSvdispatch = createAsyncThunk(
  "dispatch/exportCSvdispatch",
  async (
    {
      dispatch_type,
      filters,
      transferFilters,
      allocationFilters,
      itemsRequestFilters,
    }: any,
    thunkAPI: any
  ) => {
    try {
      const params = new URLSearchParams();
      params.append("export", "excel");

      // 🔹 Common filter handling (dispatch_date, packing_date, delivered_date etc.)
      if (filters?.length > 0) {
        filters.forEach(
          ({ filterField, filterValue }: { filterField: string; filterValue: any }) => {
            if (filterField && filterValue) {
              if (filterField === "dispatch_date") {
                if (filterValue.from_date) {
                  params.append("dispatch_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("dispatch_date_to", filterValue.to_date);
                }
              } else if (filterField === "packing_date") {
                if (filterValue.from_date) {
                  params.append("packing_details.packing_date_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("packing_details.packing_date_to", filterValue.to_date);
                }
              } else if (filterField === "delivered_date") {
                if (filterValue?.from_date) {
                  params.append("delivered_date_from", filterValue.from_date);
                }
                if (filterValue?.to_date) {
                  params.append("delivered_date_to", filterValue.to_date);
                }
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      // 🔹 Append filters by type
      const extraFilters =
        dispatch_type === "Transfer"
          ? transferFilters
          : dispatch_type === "Allocation"
          ? allocationFilters
          : dispatch_type === "Items Request"
          ? itemsRequestFilters
          : null;

      if (extraFilters) {
        Object.entries(extraFilters).forEach(([key, value]: any) => {
          if (value !== undefined && value !== "") {
            params.append(key, value as string);
          }
        });
      }

      // 🔹 API call
      const response: any = await WarehouseAxios.get(
        `/dispatch/list/?${params.toString()}`,
        { responseType: "blob" }
      );

      // 🔍 Check if response is JSON error instead of Excel
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        return thunkAPI.rejectWithValue(errorData?.message || "Export failed");
      }

      // ✅ Extract filename
      const disposition = response.headers["content-disposition"];
      let filename = "dispatch_export.xlsx";
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) filename = match[1];
      }

      // ✅ Trigger download
      const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = urlBlob;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Export failed"
      );
    }
  }
);
